import { fetchAuthSession } from 'aws-amplify/auth';
import { env } from '@/config/env';
import { ApiError } from '@/types/api';

async function getAuthHeaders(): Promise<Record<string, string>> {
  try {
    const session = await fetchAuthSession();
    const token = session.tokens?.idToken?.toString();
    return token ? { Authorization: token } : {};
  } catch {
    return {};
  }
}

export async function apiGet<T>(
  path: string,
  params?: Record<string, string>,
): Promise<T> {
  const url = new URL(`${env.apiEndpoint}${path}`);
  if (params) {
    for (const [key, value] of Object.entries(params)) {
      if (value != null) url.searchParams.set(key, value);
    }
  }

  const headers = await getAuthHeaders();
  const res = await fetch(url, { headers });

  if (!res.ok) {
    throw new ApiError(res.status, await res.text());
  }

  return res.json();
}

export async function apiPost<T>(
  path: string,
  body: Record<string, unknown>,
  params?: Record<string, string>,
): Promise<T> {
  const url = new URL(`${env.apiEndpoint}${path}`);
  if (params) {
    for (const [key, value] of Object.entries(params)) {
      if (value != null) url.searchParams.set(key, value);
    }
  }

  const headers = await getAuthHeaders();
  const res = await fetch(url, {
    method: 'POST',
    headers: { ...headers, 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    throw new ApiError(res.status, await res.text());
  }

  return res.json();
}
